import { CampaignsTable } from 'assets/js/pages/campaigns/CampaignsTable';
import { ContactsTable } from 'assets/js/pages/contacts/ContactsTable';
import { CompaniesTable } from 'assets/js/pages/contacts/companies/CompaniesTable';
import { PledgesTable } from 'assets/js/pages/pledges/PledgesTable';
import { RecurringPaymentsTable } from 'assets/js/pages/recurring-payments/RecurringPaymentsTable';
import { TransactionsTable } from 'assets/js/pages/transactions/TransactionsTable';
import { TicketsTable } from 'components/pages/tickets/TicketsTable';
import { useCurrentReport } from 'customHooks/useCurrentReport';
import { ReportResource } from 'types/domain';

const ReportTableStrategy = () => {
    const { data: report } = useCurrentReport();
    const Table = getTable(report.resource);

    return <Table enableFilters={false} enableReset={false} />;
};

const getTable = (resource: ReportResource) => {
    switch (resource) {
        case 'contacts':
            return ContactsTable;
        case 'companies':
            return CompaniesTable;
        case 'transactions':
            return TransactionsTable;
        case 'tickets':
            return TicketsTable;
        case 'campaigns':
            return CampaignsTable;
        case 'transaction_plans':
            return RecurringPaymentsTable;
        case 'pledges':
            return PledgesTable;
    }
};

export { ReportTableStrategy };
